<template>
  <EditForm type="edit" :roster="player" />
  <!-- <div class="events-list-wrap">
    Roster edit
    {{ roster }}
    <Form>
      <BaseFormInput
        name="athleteName"
        label="Name"
        :value="roster.athleteName"
        @change="event => handleValueChange(event.target.value, 'athleteName')"
      />
      <BaseFormInput
        name="city"
        label="City"
        :value="roster.city"
        @change="event => handleValueChange(event.target.value, 'city')"
      />
      <BaseInputGroup
        label="Height (Feet ~ Inches)"
        compact
        class="height-wrapper"
      >
        <BaseInput
          class="feet-input"
          :value="Number(roster.heightInFeet)"
          @change="value => handleValueChange(value, 'heightInFeet')"
        />
        <BaseInput class="divider-input" disabled placeholder="~" />
        <BaseInput
          class="inch-input"
          :value="Number(roster.heightInInch)"
          @change="value => handleValueChange(value, 'heightInInch')"
        />
      </BaseInputGroup>
      <BaseFormInput
        label="High School"
        name="highSchool"
        :value="roster.highSchool"
        @change="event => handleValueChange(event.target.value, 'highSchool')"
      />
      <BaseDatePicker picker="year" />
    </Form>
  </div> -->
</template>

<script>
import { mapGetters } from "vuex";
import { Roster } from "@/models";
import { FormModel } from "ant-design-vue";
import EditForm from "./form";

const STORE_KEY = "rosterStore";

export default {
  components: {
    Form: FormModel,
    EditForm
  },
  data() {
    return {
      roster: new Roster()
    };
  },
  mounted() {
    this.$store.dispatch(`${STORE_KEY}/getRoster`, {
      id: this.$route.params.id
    });
  },
  computed: {
    ...mapGetters({
      player: `${STORE_KEY}/player`
    })
  },
  methods: {
    handleValueChange(value, key) {
      this.roster = new Roster({ ...this.roster, [key]: value });
    },
  },
  watch: {
    player: {
      deep: true,
      handler: function(newVal) {
        this.roster = new Roster({ ...newVal });
      }
    }
  }
};
</script>

<style lang="sass"></style>
